import gql from 'graphql-tag'

const typeDefs = gql`
  type Mutation {
    updateSearchItem(searchItem: String!): String!
  }
`

export default typeDefs
